import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { Usuario } from '../models/usuario-sesion.interface';

@Injectable({ providedIn: 'root' })
export class UsuarioService {


    constructor(private http: HttpClient) { }

    create(usuario: Usuario): Observable<HttpRespuesta<Usuario>> {
        return this.http.post<HttpRespuesta<Usuario>>(environment.api.usuarios, usuario);
    }
}
